<template>
  <v-card class="mx-auto card-root" hover :disabled="disabled" :color="cardColor">
    <div class="card-content">
      <v-card-title class="text-center">{{ title }}</v-card-title>
      <v-card-text>
        <div class="text">
          {{ text }}
        </div>
      </v-card-text>
    </div>
    <div class="card-actions">
      <v-btn v-if="!disabled" :color="color" class="mt-4" @click="handleClick" block>Start</v-btn>
      <v-btn v-if="disabled" :color="color" class="mt-4" block>Coming Soon</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CustomCard',
  props: {
    disabled: Boolean,
    title: String,
    subTitle: String,
    text: String,
    toPath: String,
    color: String,
    cardColor:String,
    newTab: Boolean
  },
  emits: ['startButtonClicked'],
  methods: {
    handleClick() {
      // 如果是 E-BIO 或 E-DB 模块，发送事件让父组件处理（创建会话）
      if (this.title === 'E-BIO' || this.title === 'E-DB') {
        this.$emit('startButtonClicked');
      } else {
        // 其他模块直接跳转
        if (this.toPath) {
          if (this.newTab) {
            let routeData = this.$router.resolve({ path: this.toPath });
            window.open(routeData.href, '_blank');
          } else {
            this.$router.push(this.toPath);
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-root {
  height: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 1.2rem;
  width: 100%;
  box-sizing: border-box;
}
.card-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 1.2rem;
  padding-bottom: 0.5rem;
  overflow: hidden; /* 桌面端禁用滚动 */
}
.card-actions {
  margin-top: 1.2rem;
  padding-bottom: 1.2rem;
  width: 100%;
}
.text {
  padding: 0.7em 1.5em;
  text-align: center;
  min-height: 3.5em;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

/* 中等屏幕样式 (1600x900 等) - 增加卡片高度并减小内边距 */
@media (max-width: 1700px) and (min-width: 961px) {
  .card-root {
    height: 19rem; /* 增加卡片高度 */
  }

  .text {
    padding: 0.5em 1em; /* 减小内边距 */
    font-size: 0.9rem; /* 稍微减小字体 */
  }

  .card-actions {
    margin-top: 0.8rem;
    padding-bottom: 1rem;
  }
}

/* 移动端样式 - 允许文本区域滚动 */
@media (max-width: 960px) {
  .card-content {
    overflow-y: auto; /* 移动端启用垂直滚动 */
  }

  .text {
    overflow-y: auto; /* 文本区域可滚动 */
    max-height: 8em; /* 限制最大高度，超出可滚动 */
    -webkit-overflow-scrolling: touch; /* iOS 平滑滚动 */
  }
}
</style>